import { Box, Card, CardContent, CardActions, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';


const formatValue = (value, type) => {
    if (value == null || value === '') return '-';
    if (type === 'boolean') return value ? 'Yes' : 'No';
    if (type === 'date') return new Date(value).toLocaleDateString();
    if (type === 'array')
        return Array.isArray(value) ? (value.join(', ') || '-') : String(value);
    return String(value);
};

const DynamicCard = ({ rows, fields, onEdit, onDelete }) => {
    const visibleFields = fields
        .filter((f) => f.showInGrid)
        .sort((a, b) => a.order - b.order);

    if (!rows.length)
        return <Typography sx={{ mt: 2 }}>No records found.</Typography>;

    return (
        <Box display="flex" flexDirection="column" gap={1.5}>
            {rows.map((row, idx) => (
                <Card key={row._id || idx} variant="outlined">
                    <CardContent sx={{ pb: 0.5, pt: 1.5, px: 2 }}>
                        {visibleFields.map((f) => (
                            <Box
                                key={f.name}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                gap={1}
                                sx={{ py: 0.3 }}
                            >
                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ minWidth: 100, flexShrink: 0 }}
                                >
                                    {f.label}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ textAlign: 'right', wordBreak: 'break-word' }}
                                >
                                    {formatValue(row[f.name], f.type)}
                                </Typography>
                            </Box>
                        ))}
                    </CardContent>
                    <Divider />
                    <CardActions sx={{ justifyContent: 'flex-end', py: 1, px: 1, gap: 1 }}>
                        <Tooltip title="Delete" arrow>
                            <IconButton size="small" color="error" onClick={() => onDelete(row)}>
                                <Delete fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit" arrow>
                            <IconButton size="small" onClick={() => onEdit(row)}>
                                <Edit fontSize="small" />
                            </IconButton>
                        </Tooltip>                        
                    </CardActions>
                </Card>
            ))}
        </Box>
    );
};

export default DynamicCard;
